<template>
  <v-card flat>
    <v-list-item>
      <v-list-item-content two-line>
        <v-list-item-title class="headline">
          <v-icon>mdi-email</v-icon> {{ libelle }}
        </v-list-item-title>
        <v-list-item-subtitle>{{
          $t('administration.mails.detail.sub')
        }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-card-text class="pt-1">
      <p>{{ description }}</p>
      <v-alert color="secondary" type="info">
        Les variables permettent de rentre le contenu du mail dynamique en
        fonction du contexte. Le moteur de rendu Mustache est utilisé pour cela,
        la documentation est disponible à l'URL
        <a href="https://mustache.github.io/mustache.5.html"
          >https://mustache.github.io/mustache.5.html</a
        >.
      </v-alert>
      <v-simple-table>
        <thead>
          <tr>
            <th scope="col">Variable</th>
            <th scope="col">Type</th>
            <th scope="col">Description</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(v, i) in variables" :key="`variables-${i}`">
            <td>
              <em>{{ v.nom }}</em>
            </td>
            <td>{{ v.type }}</td>
            <td>{{ v.description }}</td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-divider class="pt-3 pb-3"></v-divider>

      <v-form ref="form" class="pt-2">
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="sujet"
              dense
              filled
              label="Sujet"
              @input="preview"
              :rules="[obligatoireRule(), serveurRule('sujet')]"
              hide-details="auto"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-input dense label="Prévisualisation du sujet" hide-details />
            <div class="body-1 preview">{{ exemple.sujet }}</div>
          </v-col>

          <v-col cols="12" md="6">
            <v-textarea
              filled
              label="Corps du mail"
              @input="preview"
              v-model="corps"
              :rules="[obligatoireRule(), serveurRule('corps')]"
              hide-details="auto"
            ></v-textarea>
          </v-col>

          <v-col cols="12" md="6">
            <v-input dense label="Prévisualisation du corps" hide-details />
            <div class="body-1 preview" v-html="this.exemple.corps"></div>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="annuler" text>Annuler</v-btn>
      <v-btn @click="sauvegarder" primary :loading="sauvegardeEnCours"
        >Sauvegarder</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash';
import toasted from '@/utils/toasted';
import ValidationRules from '@/plugins/mixins/ValidationRules';
import ServeurRule from '@/plugins/mixins/ServeurRule';
import { routeEnter } from '@/utils/entite';

const routesAction = withId => {
  withId(
    id => `administration/mail/${id}`,
    (vm, body) => {
      vm.initForm(body);
    },
  );
};

export default {
  mixins: [ValidationRules, ServeurRule],
  beforeRouteEnter: routeEnter(routesAction),
  data() {
    return {
      type: null,
      libelle: null,
      description: null,
      sujet: null,
      corps: null,
      variables: [],
      exemple: {
        sujet: null,
        corps: null,
      },
      sauvegardeEnCours: false,
      errors: {
        fields: {},
        globals: [],
      },
    };
  },
  mounted() {
    this.preview = _.debounce(this.preview, 300);
  },
  methods: {
    preview() {
      this.$api(`administration/mail/${this.type}/exemple`)
        .post({
          sujet: this.sujet,
          corps: this.corps,
        })
        .then(response => {
          this.exemple = response.body;
        });
    },
    initForm(body) {
      this.type = body.type;
      this.libelle = body.libelle;
      this.description = body.description;
      this.sujet = body.sujet;
      this.corps = body.corps;
      this.variables = body.variables;
      this.exemple = body.exemple;
    },
    annuler() {
      this.$router.push({ name: 'administration/mails/liste' });
    },
    sauvegarder() {
      this.validationServeur = false;
      if (this.$refs.form.validate()) {
        this.sauvegardeEnCours = true;
        this.$api(`administration/mail/${this.type}`)
          .post({
            sujet: this.sujet,
            corps: this.corps,
          })
          .then(() => {
            toasted.info('form.saved');
          })
          .catch(errors => {
            this.validationServeur = true;
            //mise à jours des erreurs
            const fields = {};
            this.errors.fields = fields;
            this.errors.globals = errors.globalErrors || {};

            if (errors.fieldErrors) {
              errors.fieldErrors.forEach(item => {
                if (!fields[item.field]) {
                  fields[item.field] = [];
                }
                fields[item.field].push(item);
              });
            }
            this.$refs.form.validate();
          })
          .finally(() => (this.sauvegardeEnCours = false));
      }
    },
  },
};
</script>

<style scoped>
.preview {
  color: rgba(0, 0, 0, 0.87);
}
</style>
